module.exports = __webpack_public_path__ + "static/media/garage.86262801.svg";